<template>
  <div class="fiveG-technology">
    <Header />
    <div class="container mx-auto px-4 pt-24 pb-16">
      <h1 class="text-4xl font-bold mb-8 text-center">5G技术 - 开启智能化时代的引擎</h1>

      <div class="bg-white rounded-lg shadow-lg p-8 mb-8">
        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">5G技术的引领者</h2>
          <p class="text-gray-700 mb-4">chmura云通讯在5G技术领域拥有深厚的积累和领先的创新能力，是全球5G技术标准的主要贡献者之一。我们的5G技术覆盖了从芯片、基站到核心网的全产业链，为全球通信行业的发展做出了重要贡献。</p>
          <p class="text-gray-700 mb-4">截至2025年，我们的5G技术在频谱效率、网络容量和覆盖范围等关键指标上均处于领先水平。</p>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">核心技术创新</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">大规模MIMO技术</h3>
              <p class="text-gray-700">支持64/128/256天线配置，实现频谱效率提升10倍，网络容量扩大30%。</p>
            </div>
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">毫米波通信</h3>
              <p class="text-gray-700">支持28GHz/39GHz频段，提供高达10Gbps的下载速度和毫秒级时延。</p>
            </div>
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">网络切片技术</h3>
              <p class="text-gray-700">实现物理网络的逻辑分割，为不同应用场景提供专属网络资源。</p>
            </div>
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">边缘计算</h3>
              <p class="text-gray-700">将计算和存储资源部署在网络边缘，实现数据处理的本地化，降低时延。</p>
            </div>
          </div>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">5G技术应用场景</h2>
          <p class="text-gray-700 mb-4">
            chmura云通讯5G技术广泛应用于各个领域，包括移动互联网、工业互联网、自动驾驶、远程医疗、智慧城市等。在移动互联网领域，我们的5G技术提供了高速稳定的网络连接，支持高清视频、虚拟现实等应用；在工业互联网领域，我们的5G技术实现了生产过程的实时监控和优化。
          </p>
          <p class="text-gray-700">在自动驾驶领域，我们的5G技术提供了低时延、高可靠性的网络连接，支持车辆之间的通信和协同驾驶；在远程医疗领域，我们的5G技术实现了高清视频会诊和远程手术等应用。</p>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">5G技术与行业融合</h2>
          <p class="text-gray-700 mb-4">chmura云通讯积极推动5G技术与各个行业的融合，与合作伙伴共同探索新的应用场景和商业模式。我们建立了5G联合创新实验室，与高校、研究机构和企业开展深度合作，共同推动5G技术的发展和应用。</p>
          <p class="text-gray-700">同时，我们还提供5G技术培训和认证服务，帮助合作伙伴和用户掌握5G技术，推动5G产业的发展。我们的培训课程覆盖了5G技术原理、网络部署、应用开发等多个方面，为5G产业的发展培养了大量人才。</p>
        </div>

        <div class="text-center">
          <el-button type="primary" size="large" @click="$router.push('/contact')" class="bg-blue-600 hover:bg-blue-700"> 联系我们了解更多 </el-button>
        </div>
      </div>
    </div>
    <Footer />
    <BackToTop />
  </div>
</template>

<script>
import Header from '../components/Header.vue';
import Footer from '../components/Footer.vue';
import BackToTop from '../components/BackToTop.vue';

export default {
  name: '5GTechnology',
  components: {
    Header,
    Footer,
    BackToTop
  }
};
</script>

<style scoped>
.fiveG-technology {
  padding-top: 80px;
}
</style>
